// extracted by mini-css-extract-plugin
module.exports = {"container":"ColorPicker_container__dM2my","selectedColor":"ColorPicker_selectedColor__QzgCg"};